/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

/* Component Imports */

import { Paper, Typography } from "@material-ui/core";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1.5rem",
    marginBottom: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  heading: {
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    marginBottom: "1rem",
  },
  iframe: {
    width: "100%",
    borderRadius: "4px",
    [theme.breakpoints.down("xs")]: {
      height: "12rem",
    },
    [theme.breakpoints.only("sm")]: {
      height: "23rem",
    },
    [theme.breakpoints.only("md")]: {
      height: "25rem",
    },
    [theme.breakpoints.only("lg")]: {
      height: "25rem",
    },
    [theme.breakpoints.only("xl")]: {
      height: "25rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "25rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 920)]: {
      height: "25rem",
    },
  },
  gmapSkeleton: {
    "&.MuiSkeleton-text": {
      transform: "none",
    },
  },
}));

const GoogleMap = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <Paper id="mapp" elevation={2} className={classes.paper}>
          <Typography variant="body2" component="p" className={classes.heading}>
            Locate on Map
          </Typography>
          <iframe
            src={
              props.src
                ? props.src
                : "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.751982133716!2d77.6407576!3d12.9117067!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x951dc4428b8d8174!2sBeegru!5e0!3m2!1sen!2sin!4v1627285658358!5m2!1sen!2sin"
            }
            className={classes.iframe}
            width={850}
            height={420}
            frameBorder="0"
            aria-hidden="false"
            tabIndex="0"
            loading="lazy"
          />
        </Paper>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Paper id="mapp" elevation={2} className={classes.paper}>
          <Skeleton>
            <Typography
              variant="body2"
              component="p"
              className={classes.heading}
            >
              Locate on Map
            </Typography>
          </Skeleton>
          <Skeleton className={classes.gmapSkeleton} width="100%">
            <iframe
              src={
                props.src
                  ? props.src
                  : "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.751982133716!2d77.6407576!3d12.9117067!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x951dc4428b8d8174!2sBeegru!5e0!3m2!1sen!2sin!4v1627285658358!5m2!1sen!2sin"
              }
              className={classes.iframe}
              width={850}
              height={420}
              frameBorder="0"
              aria-hidden="false"
              tabIndex="0"
              loading="lazy"
            />
          </Skeleton>
        </Paper>
      </React.Fragment>
    );
  }
};

export default GoogleMap;
